import { render, staticRenderFns } from "./classvideo.vue?vue&type=template&id=6f5d7784&scoped=true&"
import script from "./classvideo.vue?vue&type=script&lang=js&"
export * from "./classvideo.vue?vue&type=script&lang=js&"
import style0 from "./classvideo.vue?vue&type=style&index=0&id=6f5d7784&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d7784",
  null
  
)

export default component.exports